
import {
  defineComponent,
  reactive,
  toRefs,
} from 'vue'
export default defineComponent({
  name: '',
  props: {
    btnType: {
      type: String, // left-top-tag:角标
    },
    size: {
      type: String, // small：小 middle:中 big：大
    },
    bgColor: {
      type: String,
      default: '#e8e8e8',
    },
    color: {
      type: String,
      default: '#ffffff',
    },
    fontSize: {
      type: String,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    padding: {
      type: String,
    },
    borderRadius: {
      type: String,
    },
    animationName: { // 动画名
      type: String
    },
  },
  setup() {
    const data = reactive({})
    return {
      ...toRefs(data),
    }
  },
})
